export const roundToNDecimals = (number, decimals = 2) => {
	const powerOfTen = Math.pow(10, decimals);
	return Math.round(number * powerOfTen) / powerOfTen;
};
export const isALargerOrEqualToB = (a, b, digits = 2) => {
	return roundToNDecimals(a, digits) >= roundToNDecimals(b, digits);
};
